import { searchAlgolia } from 'api'

// Keeps the old `index.search(query, params)` shape so callers stay unchanged.
const proxiedIndex = indexName => ({
  search: (query, params = {}) =>
    searchAlgolia([{ indexName, params: { query, ...params } }]).then(data => data.results[0]),
})

export const profilesIndex = proxiedIndex('profiles')
export const historyProductIndex = proxiedIndex('historydatabase')
export const bidsIndex = proxiedIndex('bids')
